export const resourcesPage = {
  hero: {
    eyebrow: 'Landscape ideas & information',
    title: 'More ways to love your landscape.',
    intro:
      'Explore garden ideas, landscape information and stories from D.A. Alexander’s existing article collections.',
    image: 'https://codex.websiteforge.net/da-alexander-redesign-20261028/assets/plymouth-logo-cleaned-20261029.png',
    alt: 'Hydrangeas and hostas beneath mature garden trees.',
  },
  collections: [
    {
      id: 'love-your-landscape',
      title: 'Love Your Landscape',
      text: 'Look inside featured landscapes and hear what homeowners enjoy about their gardens and outdoor spaces.',
      action: 'Explore Love Your Landscape',
      href: 'https://www.daalexander.com/LoveYourLandscape',
    },
    {
      id: 'articles',
      title: 'Articles & landscape advice',
      text: 'Browse existing articles on planting, seasonal landscape care and ideas for enjoying your property.',
      action: 'Browse the article collection',
      href: 'https://www.daalexander.com/Blog',
    },
  ],
  closing: {
    title: 'Have a landscape idea of your own?',
    text: 'Explore residential landscape design and outdoor living, or tell us about the property you have in mind.',
    action: { label: 'Explore residential landscapes', href: '/residential-landscapes' },
    secondaryAction: { label: 'Start a conversation', href: '/contact' },
  },
};
